import { DateString, MemberPictureType, MemberTeamsType, PublicHolidayValueType, Resource } from '.';

export enum SettingValueLevel{
  DEFAULT = 'DEFAULT',
  CREW = 'CREW',
  MEMBER = 'MEMBER',
}

export type SettingValueType = {
  id: string;
  crewId?: number;
  userId?: number;
  validFrom: DateString;
  validTo: DateString;
  memberName?: string;
  isUserActive?: boolean;
  level?: SettingValueLevel;
  value:
    | boolean
    | string
    | number
    | null
    | PublicHolidayValueType[]
    | MemberPictureType
    | MemberTeamsType[]
    | Resource;
};

export type DeleteSettingValueType =
  | {
      id: string;
      userId: number;
    }
  | {
      id: string;
      validFrom: DateString;
    }
  | {
      id: string;
      userId: number;
      validFrom: DateString;
    };

export type SettingValueWithCrewIdType = {
  crewId: number;
} & SettingValueType;
